exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.min-size[data-v-14e1b558] {\n  min-width: 150px;\n}\n.max-content[data-v-14e1b558] {\n  min-width: max-content;\n}\n.size[data-v-14e1b558] {\n  height: 46px;\n}\n.input-size[data-v-14e1b558] {\n  width: 1.8rem;\n}\n.availability-info[data-v-14e1b558] {\n  border: solid 1px #f16c64;\n  border-radius: 25px;\n  padding: 10px;\n  color: #f16c64;\n}\n.avoid-text-breaking[data-v-14e1b558] {\n  white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-14e1b558","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Resume/AddTransport/AddExtraTransport.vue
// module id = 2054
// module chunks = 0